var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "aftersale-detail-table" },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.data, border: "", "max-height": "140" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "ruigu_code", label: "锐锢编码", width: "130px" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "self_code", label: "三方商品编码" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "商品名", width: "400" }
          }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { prop: "spec", label: "规格" } }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { prop: "unit", label: "单位" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "applied_num", label: "申请数量" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "applied_price", label: "申请金额" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.type === "3"
                      ? _c("div", [_vm._v("-")])
                      : _c("div", [_vm._v(_vm._s(scope.row.applied_price))])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "received_num", label: "收货数量" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "accepted_num", label: "确认数量" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "accepted_price", label: "确认金额" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.type === "3"
                      ? _c("div", [_vm._v("-")])
                      : _c("div", [_vm._v(_vm._s(scope.row.accepted_price))])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "returned_num", label: "出库数量" }
          }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { prop: "price", label: "单价" } })
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.data, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "ruigu_code", label: "锐锢编码", width: "130px" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "description", label: "用户说明" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block",
                          width: "100%",
                          "text-align": "left",
                          padding: "0 5px"
                        }
                      },
                      [_vm._v(_vm._s(scope.row.description))]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "images", label: "图片", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "img-list",
                        on: {
                          click: function($event) {
                            return _vm.checkImgs(scope.row.images)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.firstImg(scope.row.images),
                            alt: "",
                            width: "100px;"
                          }
                        })
                      ]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.showImgDialog
        ? _c("imgFloat", {
            attrs: { imgsrc: _vm.imgs, show: _vm.showImgDialog },
            on: {
              "update:show": function($event) {
                _vm.showImgDialog = $event
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "table-title" }, [
      _c("h6", [_vm._v("用户说明:")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5232a368", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5232a368","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bigAftersale/aftersale-detail-table.vue
// module id = null
// module chunks = 